// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_72-0";
export var optionCard = "_72-1";